module.exports = __webpack_public_path__ + "img/CertDoctorDriveEn.8fbb785a.jpeg";